import InstructionDetails from './InstructionDetails';

export default InstructionDetails;
